import Grid from '@mui/material/Grid2';
import { useSelector } from "react-redux";
import ViewHotelReservationInfo from "./ViewHotelReservationInfo";
import ViewServiceReservationInfo from "./ViewServiceReservationInfo";

const ManageReservationInfo = ({ item }) => {
    const { reservationOverview } = useSelector((state) => state.reservationsSummaryReducer);
    const isHotel = !!reservationOverview?.Hotels && item?.Rooms;
    const isService = !!reservationOverview?.Services && item?.Units;

    const renderReservationInfo = () => {
        if (isHotel) return <ViewHotelReservationInfo item={item} />;
        if (isService) return <ViewServiceReservationInfo item={item} />;
        return null;
    };

    return (
        <Grid container spacing={0}>
            <Grid size={12}>
                {renderReservationInfo()}
            </Grid>
        </Grid>
    );
};

export default ManageReservationInfo;